module.exports = __webpack_public_path__ + "img/img2.d37c0c72.png";